import { useLocation, useNavigate } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";

/**
 * Global Back / Forward navigation pill.
 * Mounted once in App.js (next to BrowserRouter) so it appears on every page.
 * Position: fixed top-left, just below the sticky page header — sits visually
 * near the brand logo without overlapping it.
 * Hidden on Landing (/) and Login (/login) for a cleaner first-touch surface.
 */
export default function PageNav() {
    const nav = useNavigate();
    const { pathname } = useLocation();

    // Hide on routes where back/forward would be noise.
    if (pathname === "/" || pathname === "/login") return null;

    return (
        <div
            className="fixed top-3 left-3 sm:top-4 sm:left-6 z-[60] flex items-center gap-1 bg-brand-paper/90 backdrop-blur-xl border border-brand-border rounded-full shadow-editorial p-1"
            data-testid="page-nav"
            aria-label="Page navigation"
        >
            <button
                type="button"
                onClick={() => nav(-1)}
                className="w-8 h-8 grid place-items-center rounded-full text-brand-ink hover:bg-brand-ink hover:text-brand-paper transition-all duration-300"
                aria-label="Go back"
                title="Back"
                data-testid="page-nav-back"
            >
                <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
            </button>
            <div className="w-px h-3.5 bg-brand-border" />
            <button
                type="button"
                onClick={() => nav(1)}
                className="w-8 h-8 grid place-items-center rounded-full text-brand-ink hover:bg-brand-ink hover:text-brand-paper transition-all duration-300"
                aria-label="Go forward"
                title="Forward"
                data-testid="page-nav-fwd"
            >
                <ArrowRight className="w-3.5 h-3.5" strokeWidth={1.5} />
            </button>
        </div>
    );
}
